import { v4 as uuidv4 } from 'uuid'
import NAV_PATHS from '@lib/const/nav-paths.const'

interface IFOOTER_NAVIGATION {
  id: string
  path: keyof typeof NAV_PATHS
  labelTx: string
  isExternal: boolean
}

interface IFOOTER_NAVIGATION_COLLECTION {
  leftCol: IFOOTER_NAVIGATION[]
  rightCol: IFOOTER_NAVIGATION[]
  bottomRow: IFOOTER_NAVIGATION[]
}

const FOOTER_NAVIGATION_COLLECTION: IFOOTER_NAVIGATION_COLLECTION = {
  leftCol: [
    {
      id: uuidv4(),
      path: 'visit',
      labelTx: 'nav:visit',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'whatson',
      labelTx: 'nav:exhibitionsAndEvents',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'msaSRestaurant',
      labelTx: 'nav:msaSRestaurant',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'support',
      labelTx: 'nav:support',
      isExternal: false,
    },
  ],
  rightCol: [
    {
      id: uuidv4(),
      path: 'membership',
      labelTx: 'nav:membership',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'giftShop',
      labelTx: 'nav:giftShop',
      isExternal: true,
    },
    {
      id: uuidv4(),
      path: 'press',
      labelTx: 'nav:press',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'googleArtAndCulture',
      labelTx: 'nav:googleArtAndCulture',
      isExternal: true,
    },
  ],
  bottomRow: [
    {
      id: uuidv4(),
      path: 'kvkk',
      labelTx: 'nav:kvkk',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'privacyPolicy',
      labelTx: 'nav:privacyPolicy',
      isExternal: false,
    },
    {
      id: uuidv4(),
      path: 'sabanciUniversity',
      labelTx: 'nav:sabanciUniversity',
      isExternal: true,
    },
  ],
}

const NAV_LINKS = {
  socialMedia: {
    youtube: 'https://www.youtube.com/user/sakipsabancimuzesi',
    instagram: 'https://www.instagram.com/sakipsabancimuzesi/',
    facebook: 'https://www.facebook.com/SakipSabanciMuzesi/',
    twitter: 'https://twitter.com/SSabanciMuze',
    tripadvisor:
      'https://www.tripadvisor.com.tr/Attraction_Review-g293974-d3140819-Reviews-Sakip_Sabanci_Museum-Istanbul.html',
  },
  navigation: FOOTER_NAVIGATION_COLLECTION,
}

export default NAV_LINKS
